import { createMockStockAdapter } from './mockStockAdapter'
import { createMockPredictionAdapter } from './mockPredictionAdapter'
import { createMockOddsAdapter } from './mockOddsAdapter'

export * from './types'
export { createMockStockAdapter, STOCK_UNIVERSE } from './mockStockAdapter'
export { createMockPredictionAdapter, buildSampleMarkets } from './mockPredictionAdapter'
export { createMockOddsAdapter, buildSampleOdds } from './mockOddsAdapter'

export const stockAdapter = createMockStockAdapter()
export const predictionAdapter = createMockPredictionAdapter()
export const oddsAdapter = createMockOddsAdapter()
